/* eslint no-undef: 0 */
import Vue from 'vue'
import Meta from 'vue-meta';
import VueRouter from 'vue-router'
import { Buffer } from 'buffer';
import SimulatorComponent from '../components/Simulator.vue'
import TrafficViewComponent from '../components/TrafficView.vue'

Vue.use(VueRouter);
Vue.use(Meta);
Object.defineProperty(globalThis, 'Buffer', {
  value: Buffer,
  writable: false,
  configurable: false,
});

const routes = [
  {
    path: '/',
    component: SimulatorComponent
  },
  {
    path: '/simulator',
    name: 'Simulator',
    component: SimulatorComponent, // 適切なコンポーネントを指定

  },
  {
    path: '/traffic_view',
    name: 'TrafficView',
    component: TrafficViewComponent,
  },
]

const router = new VueRouter({
  routes
});
export default router
